export default (theme) => ({
  container: {
    height: 700,
    backgroundSize: "cover",
    backgroundPosition: "center bottom",
    backgroundRepeat: "no-repeat",
  },
});
